import type {
  SeasonDetail,
  SeasonSlot,
} from "../../../shared/contracts/season.js";
import type { ProductRoute } from "../../app/product-router.js";

export function openSeasonSetup(
  season: SeasonDetail,
  slot: SeasonSlot,
  accountId: string,
  route: ProductRoute,
): void {
  const rival = season.members.find((member) => member.accountId !== accountId);
  const params = new URLSearchParams({ season: season.id, slot: slot.id });
  if (rival) params.set("vs", rival.participantId);
  route.navigate("tee-off");
  window.history.replaceState(
    null,
    "",
    `${route.pathFor("tee-off")}?${params}`,
  );
}
